import { ReactNode } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';

type Props = {
  title: string;
  content?: string;
  children?: ReactNode;
  bodyNode?: ReactNode;
};

export const Section = ({ title, content, children, bodyNode }: Props) => {
  return (
    <View className="flex-col justify-center gap-y-2 mb-4 p-2 bg-slate-50 rounded-md">
      <Text className="text-xl font-semibold text-slate-600">{title}</Text>
      <View className="w-full ml-2">
        {content || children ? (
          <Text className="text-lg text-slate-700 ">
            {content} {children}
          </Text>
        ) : null}
        {bodyNode}
      </View>
    </View>
  );
};
